import { SceneSet } from '@bighealth/types';

export const getSessionDescription = (sceneSet: SceneSet): string | undefined =>
  sceneSet?.session_description;
